import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { Stack } from "@mui/material";

import { CreateRuleForm, type CreateRuleFormProps } from "./CreateRuleForm";

export type CreateRuleTabViewProps = Omit<
  CreateRuleFormProps,
  "templateCardSize" | "composerSurface"
>;

/**
 * The rule creation page — `?rule=new`, and the rules list while the org has
 * no rules: the page heading over the shared creation form.
 *
 * The heading is the page title scale (22/30) rather than the list tabs'
 * section heading, since this page has no tab bar above it.
 */
export const CreateRuleTabView = (formProps: CreateRuleTabViewProps) => (
  <Stack spacing={8}>
    <Stack spacing={2} pt={2}>
      <IgTypography component="h1" variant="h1" fontWeight={600}>
        New rule
      </IgTypography>
      <IgTypography color="text.secondary" sx={{ lineHeight: "21px" }}>
        Describe which products should show and for whom — or start from a
        template and Atlas fills in the rest.
      </IgTypography>
    </Stack>
    <CreateRuleForm {...formProps} />
  </Stack>
);
